/**
 * Replo lattice colors as JS constants. Use these when you need the hex
 * value in inline styles, on a canvas, or when composing color strings (e.g.
 * building a `linear-gradient(...)` or appending alpha).
 *
 * `colors.brand.*` mirrors the `--color-brand-*` CSS variables in
 * `tailwind.css` — keep the two in sync when changing values. For Tailwind
 * class usage (e.g. `bg-brand-yellow`), prefer the CSS variables.
 *
 * Semantic tokens (`--color-muted`, `--color-border`, etc.) and Tailwind tone
 * scales (`--color-red-600`, etc.) intentionally live in CSS only — reaching
 * for them from JS defeats the point of CSS variables, since rebinding a
 * token in CSS would no longer reach any hardcoded JS sites. Non-brand JS
 * constants can be added flat on `colors` here as specific needs come up.
 */
export const colors = {
  brand: {
    seashell: "#f5fad9",
    yellow: "#ffeb80",
    lightGreen: "#b7feae",
    darkGreen: "#03ab8c",
    lightPink: "#ffb3c3",
    magenta: "#ef196e",
    purple: "#8b32a8",
    blue: "#274ae2",
  },
} as const;
